import { make } from './TextStyle.gen'

type TextStyleProps = React.ComponentProps<typeof make>

const TextStyle = make as React.FunctionComponent<TextStyleProps>

export { TextStyle, type TextStyleProps }
